import { getTimezoneOffset } from 'date-fns-tz';
import { deprecatedTimezoneMap } from '../shared/frontend/utils/tzDeprecated';

export const LastTimezoneOnEarth = 'Etc/GMT+12';

const LocalTimeZone =
  typeof window === 'undefined'
    ? {
        name: LastTimezoneOnEarth,
        hoursOffset: (_date: Date): number => -12,
        minsOffset: (_date: Date): number => -0,
      }
    : {
        name: '',
        hoursOffset: (date: Date): number =>
          Math.floor((-1 * new Date(date).getTimezoneOffset()) / 60),
        minsOffset: (date: Date): number =>
          Math.floor((-1 * new Date(date).getTimezoneOffset()) % 60),
      };

function determineClientTimezone(): string {
  let tz: string | undefined = Intl.DateTimeFormat().resolvedOptions().timeZone;
  let guessWithIp = false;

  if (tz) {
    tz = tz.trim();
    tz = tz || deprecatedTimezoneMap[tz];
  }

  try {
    if (!tz) throw new Error('undefined timezone');
    getTimezoneOffset(tz);
  } catch {
    tz = 'America/New_York';

    if (typeof window !== 'undefined') {
      // On client
      guessWithIp = true;
    }
  }

  if (tz === 'Etc/Unknown') {
    if (typeof window !== 'undefined') {
      // On client
      guessWithIp = true;
    } else {
      tz = LastTimezoneOnEarth;
    }
  }

  if (guessWithIp) {
    new Promise(() => {
      void (async function () {
        // Perform this async and overwrite EDate tz if necessary
        if (typeof window !== 'undefined') {
          const { attendeeIPTimezone } = require('./attendeeIPTimezone');
          LocalTimeZone.name = await attendeeIPTimezone();
        }
      })();
    });
  }

  return tz;
}

function localTimeZone(): void {
  LocalTimeZone.name = determineClientTimezone();
}

localTimeZone();

export { LocalTimeZone };
